import {z} from 'zod';

import {BigDecimalSchema} from '@dms/api/shared';

export const RateMatrixCellDataSchema = z.object({
  nominalRate: BigDecimalSchema,
  apr: BigDecimalSchema,
});

export type RateMatrixCellData = z.infer<typeof RateMatrixCellDataSchema>;
